// **The keyboard-inert-while-typing guard** (`demo-presentation-shell` task 3.11/3.12, design
// **DD11**). Deliberately generic — "is *some* text-entry surface focused right now" — rather than
// naming the B++ editor, the instruct prompt or the Beekeeper chat input specifically, so every
// text surface any later lane adds (groups 9, 10) is covered with no change here: the guard reads
// `document.activeElement`, which is true regardless of which component put focus there.

export function isTextEntryFocused(doc: Document = document): boolean {
  const active = doc.activeElement;
  if (active === null) {
    return false;
  }
  if (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA') {
    return true;
  }
  return (active as HTMLElement).isContentEditable === true;
}
